import { render, staticRenderFns } from "./select-brands.vue?vue&type=template&id=6aca3a3a&scoped=true"
import script from "./select-brands.vue?vue&type=script&lang=js"
export * from "./select-brands.vue?vue&type=script&lang=js"
import style0 from "./select-brands.vue?vue&type=style&index=0&id=6aca3a3a&prod&lang=css"
import style1 from "./select-brands.vue?vue&type=style&index=1&id=6aca3a3a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca3a3a",
  null
  
)

export default component.exports